import { node } from 'prop-types'
import { Header, List } from 'semantic-ui-react'

function GeneralInformation() {
  return (
    <div className='fade-in'>
      <Header as='h1'>
        General Information
        <Header.Subheader>Email notifications for solar radio burst activity</Header.Subheader>
      </Header>

      <div style={{ textAlign: 'justify', lineHeight: 1.6 }}>
        The system notifies users by email when solar radio bursts are detected. To start receiving alerts, open the{' '}
        <strong>User form</strong> tab in the menu and fill out the form with your email address and preferred
        notification threshold.
      </div>

      <Header as='h3' style={{ marginTop: '1rem' }}>
        How alerts work
      </Header>

      <List bulleted>
        <List.Item>
          <strong>Email address:</strong> provide a valid email to receive notifications directly.
        </List.Item>
        <List.Item>
          <strong>Threshold:</strong> select one of the recommended alert intervals
          after an event at which you wish to receive the notification.
        </List.Item>
        <List.Item>
          <strong>Delivery:</strong> alerts are automatically sent when solar activity is detected by the
          ROSIE monitoring system.
        </List.Item>
      </List>
    </div>
  )
}

GeneralInformation.propTypes = {
  children: node,
}

export default GeneralInformation
